export default "__VITE_PUBLIC_ASSET__1e4d5c07__"